<template>
	<datatable
		ref="datatable"
		:isAuth="isAuth"
		:user="user">
	</datatable>
</template>

<script>
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
				//
			}
		},
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/productAttributeLists/views/Index.vue